import dayjs from "dayjs";
import type {
    SystemStatusEventsBody,
    SystemStatusEventsBodySchemaItems as TSystemEventsItemsSchema,
} from "@/interfaces/api";

export type TMaintenanceLoaderInstance = ReturnType<
    typeof useDataLoaderWithCache<TSystemEventsItemsSchema>
>;

const SESSION_STORAGE_KEY = "system/maintenance/banners/shown";

export default async function useMaintenanceEvents() {
    const { result, promise } = useDataLoader<TSystemEventsItemsSchema>(() =>
        useNjordaApi().api.getAppV1SystemStatusEvents("planned_maintenance"),
    );
    await promise;

    let activeMaintenanceEvent: SystemStatusEventsBody | null = null;
    const upcomingMaintenanceEvents = [] as SystemStatusEventsBody[];

    (result.value?.items ?? []).forEach((event: SystemStatusEventsBody) => {
        if (event.status === "ongoing") {
            activeMaintenanceEvent = event;
            return;
        }
        if (
            event.status === "scheduled" &&
            dayjs(event.planned_start).isAfter(dayjs()) &&
            dayjs(event.planned_start).isBefore(dayjs().add(1, "week"))
        ) {
            upcomingMaintenanceEvents.push(event);
        }
    });
    const shownEventId = sessionStorage.getItem(SESSION_STORAGE_KEY);
    const upcomingMaintenanceEvent = upcomingMaintenanceEvents.sort((a, b) =>
        dayjs(a.planned_start).isAfter(dayjs(b.planned_start)) ? 1 : -1,
    )[0];

    return {
        activeMaintenanceEvent,
        upcomingMaintenanceEvent:
            upcomingMaintenanceEvent && upcomingMaintenanceEvent.id !== shownEventId
                ? upcomingMaintenanceEvent
                : null,
        setEventShownToday(id: string) {
            sessionStorage.setItem(SESSION_STORAGE_KEY, id);
        },
    };
}
